import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTypographyComponent } from "./med-icon-typography.component";

@NgModule({
  declarations: [
    MedIconTypographyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTypographyComponent,
  ],
})
export class MedIconTypographyModule { }
